export default function isTokenExpired() {
  const user = JSON.parse(localStorage.getItem('user'));

  if (user && user.jwt.payload.exp) {
    return Math.floor(Date.now() / 1000) > user.jwt.payload.exp;
  }
  return true;
}
